import { Checkbox, Textarea, makeStyles, shorthands, tokens, Dialog, DialogSurface, DialogBody, DialogTitle, DialogContent, DialogActions, DialogTrigger } from '@fluentui/react-components';
import { ThumbDislike24Filled, ThumbLike24Filled } from '@fluentui/react-icons';
import { useInputStyles } from '../Common/inputStyles';
import { FC, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { IFeedback } from '../../EnterpriseGPTApi/EnterpriseGPTApiV1Client';
import SyButton from '../Common/SyButton';

export interface DialogFeedbackAnswerProps {
    open: boolean;
    feedback?: IFeedback;
    onFeedback: (feedback?: IFeedback) => void;
}
const useStyle = makeStyles({
    dialogContent: {
        overflowX: 'hidden',
    },
    form: {
        display: 'flex',
        flexDirection: 'column',

        ...shorthands.flex(1, 1, 'auto'),
        ...shorthands.padding('0.4rem', '0.25rem'),
    },
    title: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        ...shorthands.gap('0.5rem'),
    },
    textareaWrapper: {
        marginBottom: '1rem',
    },
    checkboxGroup: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        marginLeft: '-4px',
    }
});

// shows a dialog to collect feedback
export const DialogFeedbackAnswer: FC<DialogFeedbackAnswerProps> = (props: DialogFeedbackAnswerProps) => {
    const { open, feedback, onFeedback } = props;
    const [comment, setComment] = useState<string>('');
    const [isHarmful, setIsHarmful] = useState<boolean >(false);
    const [isNotTrue, setIsNotTrue] = useState<boolean >(false);
    const [isNotHelpful, setIsNotHelpful] = useState<boolean >(false);
    const { t } = useTranslation();
    const classes = useStyle();
    const searchClasses = useInputStyles();

    useEffect(() => {
        setComment (feedback?.comment || '');
        setIsHarmful(feedback?.isHarmfullUnsafe || false);
        setIsNotHelpful(feedback?.isNotHelpful|| false);
        setIsNotTrue(feedback?.isNotTrue|| false);
    }, [feedback])

    return (
        <Dialog open={open}>
            <DialogSurface>
                <DialogBody>
                    <DialogTitle>
                        <div className={classes.title}>
                            {feedback?.positive ? <ThumbLike24Filled color={tokens.colorPaletteGreenBackground2} /> : <ThumbDislike24Filled color={tokens.colorPaletteRedBackground3} />}
                            {t('feedback.title')}
                        </div>
                    </DialogTitle>
                    <DialogContent className={classes.dialogContent}>
                       
                        <div className={`${classes.form} feedback-dialog`}>
                            <div className={classes.textareaWrapper}>
                                <Textarea className={searchClasses.input} placeholder={t('feedback.placeholder')} value={comment} onChange={(_, data) => setComment(data.value)} />
                            </div>
                            {feedback?.positive === false ? (
                                <div className={classes.checkboxGroup}>
                                    <Checkbox checked={isHarmful} label={t('feedback.harmful')} onChange={(_, data) => setIsHarmful(data.checked == true ? true : false)} />
                                    <Checkbox checked={isNotTrue} label={t('feedback.notTrue')} onChange={(_, data) => setIsNotTrue(data.checked == true ? true : false)} />
                                    <Checkbox checked={isNotHelpful} label={t('feedback.notHelpful')} onChange={(_, data) => setIsNotHelpful(data.checked == true ? true : false)} />
                                </div>
                            ) : null}
                        </div>
                    </DialogContent>
                    <DialogActions>
                        <DialogTrigger action='close'>
                            <SyButton appearance='secondary' onClick={() => onFeedback(undefined)}>
                                {t('feedback.button.cancel')}
                            </SyButton>
                        </DialogTrigger>
                        <SyButton appearance='primary' onClick={() => {
                            onFeedback({ positive: feedback?.positive as boolean, isHarmfullUnsafe: isHarmful, isNotTrue: isNotTrue, isNotHelpful: isNotHelpful, comment: comment });
                        }}>
                            {t('feedback.button.text')}
                        </SyButton>
                    </DialogActions>
                </DialogBody>
            </DialogSurface>
        </Dialog>
    );
};
